<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    search
                </mat-icon>
                <app-search-marquee #searchMarquee [searchRequestTypeEnum]="searchRequestTypeEnum"
                                    [searchRequestTileComponentTypeName]="searchRequestTileComponentTypeName">
                </app-search-marquee>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                <!--Enter search criteria to locate saved search requests-->
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <br />
                <table *ngIf="searchResult && searchResult.length > 0" mat-table [dataSource]="searchResultDatasource" class="search-result mat-elevation-z8" matSort>
                    <ng-container matColumnDef="Avatar">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                        <td mat-cell *matCellDef="let emailMessage" (click)="editItem(emailMessage.EmailMessageId)">
                            <mat-icon class="material-symbols-outlined">
                                search
                            </mat-icon>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="FromEmailAddress">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>From</th>
                        <td mat-cell *matCellDef="let emailMessage" (click)="editItem(emailMessage.EmailMessageId)">
                            {{ emailMessage.FromEmailAddress }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ToEmailAddresses">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>To</th>
                        <td mat-cell *matCellDef="let emailMessage" (click)="editItem(emailMessage.EmailMessageId)">
                            {{ emailMessage.ToEmailAddresses }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="CcEmailAddresses">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>CC</th>
                        <td mat-cell *matCellDef="let emailMessage" (click)="editItem(emailMessage.EmailMessageId)">
                            {{ emailMessage.CcEmailAddresses }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="BccEmailAddresses">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>BCC</th>
                        <td mat-cell *matCellDef="let emailMessage" (click)="editItem(emailMessage.EmailMessageId)">
                            {{ emailMessage.BccEmailAddresses }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Subject">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Subject</th>
                        <td mat-cell *matCellDef="let emailMessage" (click)="editItem(emailMessage.EmailMessageId)">
                            {{ emailMessage.Subject }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="SentOnUTC">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Sent On (UTC)</th>
                        <td mat-cell *matCellDef="let emailMessage" (click)="editItem(emailMessage.MessageId)">
                            {{ emailMessage.SentOnUTC }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="CreatedOnUTC">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created On (UTC)</th>
                        <td mat-cell *matCellDef="let emailMessage" (click)="editItem(emailMessage.MessageId)">
                            {{ emailMessage.CreatedOnUTC }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Delete">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                        <td mat-cell *matCellDef="let emailMessage">
                            <button mat-button (click)="deleteItem(emailMessage.EmailMessageId, emailMessage.Subject)">
                                <mat-icon class="material-symbols-outlined">
                                    delete_forever
                                </mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </form>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>

